<div class="h-full" [ngSwitch]="modalName">
	<div class="flex h-full flex-col overflow-hidden">
		<div class="dialog-header">
			@if (modalName === "incompleteObsModal") {
				<div class="flex items-start gap-3">
					<span
						class="flex size-9 shrink-0 items-center justify-center rounded-full bg-red-20 text-red"
						aria-hidden="true"
					>
						<mat-icon class="!text-[22px] !leading-none">warning</mat-icon>
					</span>
					<div class="min-w-0 pt-1">
						<div class="text-base font-bold leading-snug text-red">{{ modalTitle }}</div>
						@if (modalContent?.groups?.length) {
							<div class="mt-0.5 text-xs font-medium text-red-90">Action required before sign-off</div>
						}
					</div>
				</div>
			} @else if (modalName === "obCommentsModel" && newComment.candidateName) {
				<div>
					<div class="text-sm text-grey-60">{{ modalTitle }}</div>
					<div class="mt-1 flex items-center gap-2">
						<span class="text-grey-90 text-sm font-bold">{{ newComment.candidateName }}</span>
						@if (newComment.candidateRoleLabel) {
							<span
								class="ts1-role-badge"
								[class.ts1-role-badge--pf]="newComment.candidateRole === CandidateRole.PF"
								[class.ts1-role-badge--pm]="newComment.candidateRole === CandidateRole.PM"
								>{{ newComment.candidateRoleLabel }}</span
							>
						}
					</div>
				</div>
			} @else if (modalName === "disableCommentPromptsModal") {
				<div class="text-base font-bold leading-snug text-grey-90">{{ modalTitle }}</div>
			} @else {
				<div class="text-sm text-grey-60">{{ modalTitle }}</div>
			}
		</div>
		<div
			class="dialog-content"
			[class.dialog-content--no-scroll]="modalName === 'obCommentsModel' || modalName === 'temCommentsModal'"
			[class.dialog-content--scrollable]="modalName === 'incompleteObsModal'"
		>
			<!-- todo: add contents -->
			<div *ngIf="modalName === 'default'">
				<div>{{ modalContent }}</div>
			</div>
			<div *ngIf="modalName === 'repeatCandidateModal'" class="repeat-candidate-modal">
				<p class="text-grey-70 text-sm">{{ repeatCandidateMessage }}</p>
				<mat-radio-group
					class="repeat-candidate-modal__options mt-4 flex flex-col gap-3"
					[formControl]="repeatCandidateIdControl"
				>
					@for (option of repeatCandidateOptions; track option.candidateId) {
						<mat-radio-button [value]="option.candidateId" [disabled]="option.disabled">
							{{ option.label }}
						</mat-radio-button>
					}
				</mat-radio-group>
			</div>
			<div *ngIf="modalName === 'disableCommentPromptsModal'" class="space-y-3 text-sm leading-relaxed text-grey-90">
				<p>
					When <strong>Enable Comment</strong> is turned off, comment pop-ups will not appear when Observable Behaviours
					(OBs) are added or removed.
				</p>
				<p>
					You may continue making changes without entering comments immediately; however, a comment will still be
					required for each added or removed OB before the assessment can be signed off.
				</p>
				<p>Please ensure all OB changes are reviewed and commented on before submission.</p>
			</div>
			<div *ngIf="modalName === 'error-modal'">
				<app-cbta-error-modal-content [errorMessage]="modalContent"></app-cbta-error-modal-content>
			</div>
			<div *ngIf="modalName === 'incompleteObsModal'" class="incomplete-obs-modal">
				<div class="rounded border border-red-20 bg-red-light px-3 py-2.5">
					<p class="text-sm font-medium leading-relaxed text-red-90">
						{{ modalContent?.message }}
					</p>
				</div>
				@if (modalContent?.groups?.length) {
					<div class="mt-4 flex flex-col gap-4">
						@for (group of modalContent.groups; track group.candidateName) {
							<div class="rounded border border-grey-20 bg-white px-3 py-2.5">
								<div class="text-grey-90 text-sm font-bold">{{ group.candidateName }}</div>
								<ul class="mt-2 flex flex-col gap-1.5">
									@for (item of group.items; track $index) {
										<li class="text-grey-70 flex gap-2 text-sm leading-snug">
											<span class="shrink-0 font-bold text-red">•</span>
											<span class="min-w-0">
												@if (item.maneuver) {
													<span>{{ item.maneuver }}</span>
													<span class="text-grey-50"> · </span>
												}
												<span
													class="font-semibold"
													[class.text-green]="item.action === true"
													[class.text-red]="item.action === false"
													[class.text-grey-90]="item.action !== true && item.action !== false"
												>
													{{ item.ob }}
												</span>
												@if (item.role) {
													<span class="text-grey-60"> ({{ item.role }})</span>
												}
												@if (item.action === true) {
													<span class="font-semibold text-green">{{ " { added }" }}</span>
												} @else if (item.action === false) {
													<span class="font-semibold text-red">{{ " { removed }" }}</span>
												}
											</span>
										</li>
									}
								</ul>
							</div>
						}
					</div>
				}
			</div>
			<div *ngIf="modalName === 'switchRoleModal'">
				<app-cbta-switch-role-modal></app-cbta-switch-role-modal>
			</div>
			<div *ngIf="modalName === 'signaturePadModal'">
				<app-cbta-signature-pad
					[dataUrl]="$safeNavigationMigration(signatureData?.dataUrl)"
					(onSignatureChange)="onSignatureChange($event)"
				></app-cbta-signature-pad>
			</div>

			<div *ngIf="modalName === 'temCommentsModal'">
				<div>
					<div class="mb-2 flex items-center gap-2">
						<div class="flex flex-1 flex-wrap items-center gap-2">
							@if (temComment?.typeLabel === "Maneuver Ratings" || temComment?.typeLabel === "Maneuver Outcome") {
								<span>{{ temComment?.typeLabel }}</span>
							}
							<span>{{ temComment?.maneuver }}</span>
							@if (
								temComment?.typeLabel &&
								temComment?.typeLabel !== "Maneuver Outcome" &&
								temComment?.typeLabel !== "Maneuver Ratings"
							) {
								<span
									[class.text-teal]="
										temComment?.typeLabel === 'TEM Safety Outcome' || temComment?.typeLabel === 'Rating per Competency'
									"
									>{{ temComment?.typeLabel ?? "TEM" }}</span
								>
							}
							@if (temComment?.slotLabel) {
								<span class="text-grey-60">·</span>
								<span
									[class.text-green]="temComment?.rating === 5"
									[class.text-red]="temComment?.rating === 1"
									[class.text-yellow]="temComment?.rating === 2 || temComment?.rating === 3"
									[class.text-green-90]="temComment?.rating === 4"
									>{{ temComment?.slotLabel }}</span
								>
							} @else if (
								temComment?.typeLabel &&
								temComment?.typeLabel !== "Maneuver Outcome" &&
								temComment?.typeLabel !== "Maneuver Ratings"
							) {
								<span class="text-grey-60">·</span>
							}
							<span
								[class.text-green]="temComment?.rating === 5"
								[class.text-red]="temComment?.rating === 1"
								[class.text-yellow]="temComment?.rating === 2 || temComment?.rating === 3 || temComment?.rating === -1"
								[class.text-green-90]="temComment?.rating === 4"
							>
								{{ "{ " + temComment?.remarks + " }" }}
							</span>
						</div>

						@if (showSwitch) {
							<div>
								<span class="mr-1" [class.text-violet]="!obPilotSwitch.value" [class.font-bold]="!obPilotSwitch.value"
									>PF</span
								>
								<mat-slide-toggle [formControl]="obPilotSwitch">&nbsp;</mat-slide-toggle>
								<span [class.text-violet]="obPilotSwitch.value" [class.font-bold]="obPilotSwitch.value">PM</span>
							</div>
						}
					</div>
					<div>
						<textarea
							[formControl]="temCommentControl"
							class="border-bg-grey-20 h-[180px] w-full resize-none border p-4"
							placeholder="Add comment..."
							[attr.maxlength]="getCommentMaxLength()"
						></textarea>
						<p *ngIf="temCommentControl" class="text-right">
							<span class="text-grey-90 text-[10px]">{{ commentLengthLabel(temCommentControl.value.length) }}</span>
						</p>
						@if (commentAiAssist) {
							<app-comment-ai-assist-toolbar
								[commentControl]="temCommentControl"
								(replace)="onSubmit()"
							></app-comment-ai-assist-toolbar>
						}
					</div>
				</div>
				<!-- <div>
          <div class="flex flex-row gap-2 justify-start text-[12px]">
            <span class="w-[90px]">{{ temComment?.maneuver }}</span>
            <span
              class="w-[65px]"
              [class.text-green]="temComment?.rating === 5"
              [class.text-red]="(temComment?.rating ?? 0) <= 1"
              [class.text-yellow]="(temComment?.rating ?? 0) === -1"
              >TEM</span
            >
            <span
              class="w-[90px]"
              [class.text-green]="temComment?.rating === 5"
              [class.text-red]="(temComment?.rating ?? 0) <= 1"
              [class.text-yellow]="(temComment?.rating ?? 0) === -1"
            >
              {{ "{ " + temComment?.remarks + " }" }}
            </span>
            <span class="w-[150px]">
              <textarea
                [formControl]="temCommentControl"
                class="w-full h-[50px] border-0"
                placeholder="Add comment..."
                maxlength="300"
              >
              </textarea>
              <p *ngIf="temCommentControl" class="text-right">
                <span class="text-[10px] text-grey-90"
                  >({{ temCommentControl.value.length + " / 300" }})</span
                >
              </p>
            </span>
          </div>
        </div> -->
			</div>
			<div *ngIf="modalName === 'obCommentsModel'">
				<div>
					<div class="mb-2 flex items-center justify-between gap-2">
						<div class="flex items-center gap-2">
							<span>{{ newComment.maneuver }}</span>
							@if (newComment.isObservationComment) {
								<span>{{ newComment.ob }}</span>
							} @else {
								<span [class.text-green]="newComment.action" [class.text-red]="!newComment.action">{{
									newComment.ob
								}}</span>
								<span [class.text-green]="newComment.action" [class.text-red]="!newComment.action">
									{{ newComment.action ? "{ add }" : "{ remove }" }}
								</span>
							}
						</div>
						@if (showSwitch) {
							<div>
								<span class="mr-1" [class.text-violet]="!obPilotSwitch.value" [class.font-bold]="!obPilotSwitch.value"
									>PF</span
								>
								<mat-slide-toggle [formControl]="obPilotSwitch">&nbsp;</mat-slide-toggle>
								<span [class.text-violet]="obPilotSwitch.value" [class.font-bold]="obPilotSwitch.value">PM</span>
							</div>
						}
					</div>
					<div>
						<textarea
							[formControl]="addObComments"
							class="border-bg-grey-20 h-[180px] w-full resize-none border p-4"
							placeholder="Add comment..."
							[attr.maxlength]="getCommentMaxLength()"
						></textarea>
						<p *ngIf="addObComments" class="text-right">
							<span class="text-grey-90 text-[10px]">{{ commentLengthLabel(addObComments.value.length) }}</span>
						</p>
						@if (commentAiAssist) {
							<app-comment-ai-assist-toolbar
								[commentControl]="addObComments"
								(replace)="onSubmit()"
							></app-comment-ai-assist-toolbar>
						}
					</div>
				</div>
				<!-- <div>
          <div
            class="flex flex-row gap-2 justify-start mb-1 text-[12px]"
            *ngFor="let comment of modalContent; let i = index"
          >
            <span class="w-[90px]">{{ comment?.maneuver }}</span>
            <span
              class="w-[80px]"
              [class.text-green]="comment?.action"
              [class.text-red]="!comment?.action"
              >{{ comment?.ob }}</span
            >
            <span
              class="w-[75px]"
              [class.text-green]="comment?.action"
              [class.text-red]="!comment?.action"
            >
              {{ comment?.action ? "{ added }" : "{ removed }" }}
            </span>
            <div class="w-[150px] relative">
              <span
                class="w-[150px] absolute top-0 left-0 truncate hover:drop-shadow-md hover:p-2 hover:overflow-visible hover:whitespace-break-spaces rounded-sm cursor-pointer bg-white hover:z-[10]"
                >{{ comment?.instructorComment }}</span
              >
            </div>
          </div>

          <div class="flex flex-row gap-2 justify-start text-[12px]">
            <span class="w-[90px]">{{ newComment.maneuver }}</span>
            <span
              class="w-[80px]"
              [class.text-green]="newComment.action"
              [class.text-red]="!newComment.action"
              >{{ newComment.ob }}</span
            >
            <span
              class="w-[75px]"
              [class.text-green]="newComment.action"
              [class.text-red]="!newComment.action"
            >
              {{ newComment.action ? "{ add }" : "{ remove }" }}
            </span>
            <span class="w-[150px]">
              <textarea
                [formControl]="addObComments"
                class="w-full h-[50px] border-0"
                placeholder="Add comment..."
                maxlength="300"
              >
              </textarea>
              <p *ngIf="addObComments" class="text-right">
                <span class="text-[10px] text-grey-90"
                  >({{ addObComments.value.length + " / 300" }})</span
                >
              </p>
            </span>
          </div>
        </div> -->
			</div>

			<!-- view comments modal -->
			<!-- summary -->
			<div *ngIf="modalName === 'viewSummaryModal'">
				<app-cbta-view-summary-modal
					[comments]="modalContent"
					[traineeAssessmentId]="modalTraineeAssessmentId"
				></app-cbta-view-summary-modal>
			</div>
			<!-- other comments -->
			<div *ngIf="modalName === 'viewOtherSummaryModal'">
				<app-cbta-view-summary-modal
					[instructorComments]="modalContent"
					[traineeAssessmentId]="modalTraineeAssessmentId"
				></app-cbta-view-summary-modal>
			</div>
			<!-- other comments new form -->
			<div *ngIf="modalName === 'viewRatingSummaryModal'">
				<app-cbta-form-summary-modal
					[comments]="modalContent"
					[traineeAssessmentId]="modalTraineeAssessmentId"
				></app-cbta-form-summary-modal>
			</div>

			<!-- other comments new form -->
			<div *ngIf="modalName === 'viewSummaryFlexibleManueverModal'">
				<app-form-summary-modal
					[comments]="modalContent"
					[traineeAssessmentId]="modalTraineeAssessmentId"
				></app-form-summary-modal>
			</div>

			<div *ngIf="modalName === 'viewTs1V3SummaryModal'">
				<app-ts1-v3-form-summary-modal
					[comments]="modalContent"
					[traineeAssessmentId]="modalTraineeAssessmentId"
					[reviewLayout]="modalReviewLayout"
					[activeCandidateId]="modalCandidateId"
				></app-ts1-v3-form-summary-modal>
			</div>

			<!-- /view comments modal -->

			<div *ngIf="modalName === 'signOffModal'">
				<app-cbta-signoff-modal
					[lockedStaffNumber]="lockedStaffNumber"
					(signoffFormValue)="getSignoffFormValue($event)"
				></app-cbta-signoff-modal>
			</div>
			<div *ngIf="modalName === 'OtherCommentsModal'">
				<app-cbta-other-comments-modal
					(otherCommentsValue)="getOtherCommentsValue($event)"
					(replaceSave)="onSubmit()"
					[commentAiAssist]="commentAiAssist"
					[maneuver]="maneuverOtherComments.maneuver"
					[otherComment]="maneuverOtherComments.otherComent"
				></app-cbta-other-comments-modal>
			</div>
			<div *ngIf="modalName === 'OtherTrainingCommentsModal'">
				<app-cbta-other-comments-modal
					(otherCommentsValue)="getOtherCommentsValue($event)"
					(replaceSave)="onSubmit()"
					[commentAiAssist]="commentAiAssist"
					[maneuver]="''"
					[otherComment]="maneuverOtherComments.otherComent"
				></app-cbta-other-comments-modal>
			</div>
		</div>
		<div
			*ngIf="!noAction"
			class="dialog-footer"
			[class.dialog-footer--end]="modalName === 'incompleteObsModal' || (noCloseBtn && !showSkipComment)"
		>
			<button
				*ngIf="!noCloseBtn"
				(click)="closeModal()"
				class="aa-btn min-w-20"
				data-variant="tertiary"
				data-size="small"
			>
				{{ modalBtnCancelText }}
			</button>
			<div *ngIf="!(modalName === 'incompleteObsModal' || (noCloseBtn && !showSkipComment))" class="flex-1"></div>
			<button
				*ngIf="showSkipComment && modalName === 'obCommentsModel'"
				(click)="skipComment()"
				class="aa-btn min-w-20"
				data-variant="tertiary"
				data-size="small"
			>
				Skip Comment
			</button>
			<button
				*ngIf="!noSaveBtn && !usesCommentAiToolbar()"
				[disabled]="isCommentEmpty() || isTemCommentEmpty() || isRepeatCandidateConfirmDisabled()"
				(click)="onSubmit()"
				class="aa-btn min-w-20"
				[attr.data-variant]="modalName === 'incompleteObsModal' ? 'primary' : 'secondary'"
				data-size="small"
			>
				{{ modalBtnConfirmText }}
			</button>
		</div>
	</div>
</div>
